
import {  DocumentNode } from "graphql"
import { useAppoloStore, useMainStore } from "../../../settings/zustand" 
import { 
    getChangeName,
    getInputTypeName,
    getMutationArgs,
    getQueryArgs, 
    getQueryName, 
    mutationEdit, 
    querySingle, 
    querySingleName, 
} from "src/libs/layouts" 
import {  
    GET_GQL_SCHEMA
} from "./actionTypes"  
import { setRequestError } from "src/settings/errorControllers/setRequestError"
const { gql } = require("@apollo/client/core")

const asyncControllers =  async(action:string, data: any) => {
    let response : any, 
        query : DocumentNode,
        query_name : string, fields : any
        
    const apolloClient: any = useAppoloStore.getState().client
    
    try {
        switch( action )
        {
            case GET_GQL_SCHEMA: 
                query = gql`query getGQLSchema { getGQLSchema }`
                response = await apolloClient.query({
                    query,
                    variables: {
                        input: data
                    }
                })      
                return response   
            default: 
                return  new Promise<any>( (resolve, reject) => { resolve(`Unknown action type: ${action}`)} )
        }
    }
    catch( error: any ) {
        console.log( action, data, error )
        setRequestError( action, data, error )
        return response
    }
    finally {
        return response
    }
}
export default asyncControllers